import * as yup from "yup";

export const socialsSchema = yup.object({
  facebook: yup
    .string()
    .url("Invalid URL")
    .required("Facebook url is required"),
  instagram: yup
    .string()
    .url("Invalid URL")
    .required("Instagram url is required"),
  whatsApp: yup.string().url("Invalid URL").required("WhatsApp url is required")
});
